import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  mainSwiper: 'data-main-swiper',
  thumbSwiper: 'data-thumb-swiper',
  autoPlay: 'data-autoplay',
}
const qsAll = {
  sections: 'data-section-type="image-with-text"',
}

const initSwiper = (section) => {
  const thumbSwiper = new Swiper(section.querySelector(`[${qs.thumbSwiper}]`), {
    speed: 500,
    slidesPerView: 1,
    effect: 'fade',
    allowTouchMove: false,
  })
  const mainSwiper = new Swiper(section.querySelector(`[${qs.mainSwiper}]`), {
    speed: 500,
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    autoplay: parseInt(section.querySelector(`[${qs.autoPlay}]`).dataset.autoplay) > 0 ? {
      delay: parseInt(section.querySelector(`[${qs.autoPlay}]`).dataset.autoplay) * 1000,
    } : false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper
    },
  })
}

export const setupImageWithText = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSwiper(section))
}